import React from 'react';
import { motion } from 'framer-motion';
import { Star, BookOpen, Users, Sparkles, Printer, Smartphone } from 'lucide-react';
export function PricingCards() {
  return <section id="pricing" className="py-20 bg-gray-50" data-id="element-220">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-221">
        <div className="text-center mb-12" data-id="element-222">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-3 font-[700] font-[Inter,_sans-serif]" data-id="element-223">
            📦 ¿QUÉ INCLUYE EL MEGAPACK?
          </h2>
          <p className="text-gray-600 text-[14px] font-[700]" data-id="element-224">
            “Acceso inmediato despues de comprar” “Pago 100% seguro” imprimirlas
            en papel adhesivo y te quedan igual que las originales. ¡Solo
            recortás y pegás! Sin Repetidas, Con todos tus ídolos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch" data-id="element-225">
          {/* Pack 2 — MÁS VENDIDA — ahora primero */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-2xl border-4 border-wc-yellow overflow-hidden flex flex-col relative" data-id="element-226">
            <div className="absolute top-0 left-0 w-full bg-wc-yellow text-wc-dark text-center py-1.5 font-bold tracking-widest text-xs uppercase flex items-center justify-center gap-2 z-10" data-id="element-227">
              <Star size={14} fill="currentColor" data-id="element-228" /> LA MÁS ELEGIDA{' '}
              <Star size={14} fill="currentColor" data-id="element-229" />
            </div>

            <div className="bg-wc-dark p-5 pt-10 text-center border-b border-gray-800" data-id="element-230">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-wc-yellow text-wc-dark rounded-full mb-3" data-id="element-231">
                <span className="text-xl font-bold" data-id="element-232">👑</span>
              </div>
              <h3 className="text-white mb-1 text-[14px] font-[Inter,_sans-serif]" data-id="element-233">
                ✅ Album mundial 2026 + Todas sus Figuritas + Los Mundiales más
                Épicos de la Historia
              </h3>
              <h4 className="text-base font-bold text-wc-yellow mb-3 font-[Avenir,_sans-serif]" data-id="element-234">
                MEGAPACK HISTÓRICO COMPLETO
              </h4>
              <div className="flex items-center justify-center gap-2" data-id="element-235">
                <span className="text-lg text-gray-400 line-through" data-id="element-236">
                  $45.000
                </span>
                <span className="text-4xl font-display text-white" data-id="element-237">
                  $22.990
                </span>
              </div>
            </div>

            <div className="p-5 flex-1 flex flex-col" data-id="element-238">
              <div className="mb-4 pb-4 border-b border-gray-200" data-id="element-239">
                <p className="font-bold text-center text-gray-900 text-[12px]" data-id="element-240">
                  Descarga inmediata y acceso de por vida. Si perdés los
                  archivos, te los volvemos a enviar sin cargo. Seguridad de que
                  su inversión está protegida.
                </p>
              </div>

              <ul className="space-y-2 flex-1 text-sm" data-id="element-241">
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-242">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-243" />
                  <span className="font-bold text-gray-900" data-id="element-244">
                    BONO 1: Álbum + Figuritas Qatar 2022
                  </span>
                </li>
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-245">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-246" />
                  <span className="font-bold text-gray-900" data-id="element-247">
                    BONO 2: Álbum + Figuritas Rusia 2018
                  </span>
                </li>
                <li className="flex items-center gap-2 bg-yellow-50 p-2.5 rounded-lg border border-yellow-100" data-id="element-248">
                  <Star className="w-4 h-4 text-wc-yellow flex-shrink-0" fill="currentColor" data-id="element-249" />
                  <span className="font-bold text-gray-900" data-id="element-250">
                    BONO 3: Álbum + Figuritas Sudáfrica 2010
                  </span>
                </li>
              </ul>

              <div className="mt-4 p-3 bg-gray-50 rounded-lg italic text-gray-600 text-center text-xs" data-id="element-251">
                💬 "Una colección histórica completa que no vas a encontrar en
                ningún otro lado."
              </div>

              <a href="https://www.digitalbibliotec.online/cart/52276164100378:1" target="_blank" rel="noopener noreferrer" className="w-full mt-4 bg-wc-red hover:bg-red-700 text-white font-bold py-4 rounded-xl text-lg transition-transform transform hover:scale-105 shadow-lg text-center block" data-id="element-252">
                ⭐ PACK HISTÓRICO — MÁS ELEGIDO
              </a>
            </div>
          </motion.div>

          {/* Pack 1 — ahora segundo */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-253">
            <div className="p-5 text-center border-b border-gray-200 bg-[#053491]" data-id="element-254">
              <div className="inline-flex items-center justify-center w-12 h-12 text-white rounded-full mb-3 bg-[#DFE5F1]" data-id="element-255">
                <span className="text-xl font-bold" data-id="element-256">🥇</span>
              </div>
              <h3 className="mb-1 text-[16px] font-[800] font-[Inter,_sans-serif] text-[#F4F98E]" data-id="element-257">
                ALBUM MUNDIAL 2026 + TODAS LAS FIGURITAS
              </h3>
              <h4 className="mb-3 text-[12px] font-[700] font-[Roboto,_sans-serif] text-[#E3E7F0]" data-id="element-258">
                Descarga inmediata y acceso de por vida. Si perdés los archivos,
                te los volvemos a enviar sin cargo. Seguridad de que su
                inversión está protegida
              </h4>
              <div className="text-4xl font-display text-[#FBFB81]" data-id="element-259">
                $15.990
              </div>
            </div>

            <div className="p-5 flex-1 flex flex-col" data-id="element-260">
              <ul className="space-y-3 flex-1 text-sm" data-id="element-261">
                <li className="flex gap-3" data-id="element-262">
                  <BookOpen className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-263" />
                  <div data-id="element-264">
                    <p className="font-bold text-gray-900" data-id="element-265">
                      Álbum Mundial 2026 Completo
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-266">
                      Listo para imprimir, igual al original Panini
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-267">
                  <Users className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-268" />
                  <div data-id="element-269">
                    <p className="font-bold text-gray-900" data-id="element-270">
                      Figuritas de TODOS los equipos
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-271">
                      Argentina, Brasil, Francia, Portugal, España, México,
                      Colombia y más
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-272">
                  <Sparkles className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-273" />
                  <div data-id="element-274">
                    <p className="font-bold text-gray-900" data-id="element-275">
                      Figuritas Especiales
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-276">
                      Las más codiciadas del álbum
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-277">
                  <Printer className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-278" />
                  <div data-id="element-279">
                    <p className="font-bold text-gray-900" data-id="element-280">
                      Instructivo de Impresión
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-281">
                      Guía paso a paso para imprimir en casa o en copistería
                    </p>
                  </div>
                </li>
                <li className="flex gap-3" data-id="element-282">
                  <Smartphone className="w-5 h-5 text-wc-blue flex-shrink-0 mt-0.5" data-id="element-283" />
                  <div data-id="element-284">
                    <p className="font-bold text-gray-900" data-id="element-285">
                      Acceso Digital Inmediato
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-286">
                      Lo recibís al instante en tu correo
                    </p>
                  </div>
                </li>
              </ul>

              <a href="https://www.digitalbibliotec.online/cart/52276163608858:1" target="_blank" rel="noopener noreferrer" className="w-full mt-5 bg-wc-blue hover:bg-blue-800 text-white font-bold py-3 rounded-xl text-base transition-colors text-center block" data-id="element-287">
                PACK BÁSICO
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}